<template lang="pug">
button.btn.btn-default(type="button" v-on:click="toggle()")
  | {{ label }}
  |
  i.fa(:class="iconClass")
</template>

<script>
  module.exports = {
    props: {
      showLabel: {
        type: String,
        default: () => 'Show'
      },

      hideLabel: {
        type: String,
        default: () => 'Hide'
      },

      modelValue: {
        type: Boolean,
        default() { return false }
      }
    },

    data() {
      return {shown: false}
    },

    watch: {
      modelValue() {
        this.shown = this.modelValue
      },

      shown() {
        // For component v-model support
        this.$emit('update:modelValue', this.shown)
      }
    },

    computed: {
      label() {
        return this.shown ? this.hideLabel : this.showLabel
      },
      iconClass() {
        return { "fa-angle-up": this.shown, "fa-angle-down": !this.shown }
      }
    },

    mounted() {
      this.shown = this.modelValue
    },

    methods: {
      toggle() {
        this.shown = !this.shown
      }
    }
  }
</script>
